import { createCognitoConfigSettings } from "../../../helpers/cognito-settings";
import { ForgotPasswordSubmitRequest } from "@simplyhealth/iam_client_lib";

export function createForgotPasswordSubmitRequest(
  email: string,
  code: string,
  newPassword: string
): ForgotPasswordSubmitRequest {
  return {
    config: createCognitoConfigSettings(),
    username: email.toLowerCase(),
    code,
    newPassword
  };
}
